<template>
<div>
    <div class="ibox animated fadeInRightBig">
		<div class="ibox-title">
			<h3>Editar Motivo de Ausência <i class="fa fa-industry" style="float:right;font-size:21px;margin-top: -5px;"></i></h3>
		</div>
        <form id="form" @submit.prevent>
            <div class="ibox-content">
                <div class="row">
                    <div class="form-group col-md-10">
                        <label for="name"><span class="required">*</span> Nome do Motivo de Ausência</label>
                        <input type="text" class="form-control" name="name" v-model="absenceReason.name" id="name">
                    </div>
                </div>
            </div>
			<div class="ibox-footer">
                <div class="pull-right">
                    <router-link to="/absence-reasons" class="btn btn-info">
                        <i class="fa fa-arrow-left"></i> Voltar
                    </router-link>
                    <a class="btn btn-success" @click="save">
                        Salvar <i class="fa fa-save"></i>
                    </a>
                </div>
                <p><span class="required">*</span> Campos Obrigatórios</p>
                <div class="clearfix"></div>
            </div>
        </form>
    </div>
</div>
</template>


<script>
    export default {
        data() {
            return {
                absenceReason: {
                    name: '',
                },
                errors: undefined
            }
        },
        computed: {},
        methods: {
            save: function () {
                const self = this;
                const id   = self.$route.params.id;
                const api  = self.$store.state.api + 'absence-reasons/' + id;

                let form  = new FormData();

                form.append('name', self.absenceReason.name);
                form.append('_method', 'PUT');

                self.$http.post(api, form)
                    .then((response) => {
                        self.$message('Sucesso', `Motivo de Ausência atualizado com sucesso`, 'success');
                        this.$router.push('/absence-reasons');
                    })
                    .catch((error) => {
                        self.errors = error.response.data;

                        if(typeof self.errors === 'object'){
                            let html = '<ul>';

                            $.each(self.errors, function(key, value){
                                html += '<li>' + value[0] + '</li>';
                            });

                            html += '</ul>';

                            self.errors = html;
                        }

                        self.$message(null, self.errors, 'error');
                    });
            },
            getAbsenceReason(){
                const self = this;
                const id   = self.$route.params.id;
                const api  = self.$store.state.api + 'absence-reasons/' + id;

                self.$http.get(api)
                    .then((response) => {
                        self.absenceReason = response.data.data[0];
                    })
                    .catch((error) => {
                       self.$message(null, 'Ocorreu um erro ao buscar as informações do Motivo de Ausência', 'error');
                    });
            }
        },
        mounted: function(){
            this.getAbsenceReason();
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.margin-top-20 {
    margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/AbsenceReason/Edit.vue